import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

export const requiresAuthentication = (MyComponent) => {
  class AuthenticationInterface extends Component {
    render () {
      return (
        <div style={{ flex: 1, width: '100%', height: '100%' }}>
          {!this.props.token
            ? <Redirect to='/login' />
            : <MyComponent {...this.props} />
          }
        </div>
      )
    }
  }

  const mapStateToProps = (state) => ({
    token: state.userReducer.token
  })

  return connect(mapStateToProps)(AuthenticationInterface)
}

export const noAuthentication = (MyComponent) => {
  class AuthenticationInterface extends Component {
    render () {
      return (
        <div style={{ flex: 1, width: '100%', height: '100%' }}>
          {!this.props.token
            ? <MyComponent {...this.props} />
            : <Redirect to='/' />
          }
        </div>
      )
    }
  }

  const mapStateToProps = (state) => ({
    token: state.userReducer.token
  })

  return connect(mapStateToProps)(AuthenticationInterface)
}



// WEBPACK FOOTER //
// ./src/services/AuthInterface.js